import type { ValidationErrorResponse } from "./validationErrorResponse.server";

export const isValidationError = (data: unknown) => {
  return (
    !!data &&
    typeof data === "object" &&
    ("globalErrors" in data || "fieldErrors" in data)
  );
};

export const validationErrorToString = (error: ValidationErrorResponse) => {
  let str = "";
  //TODO
  // ((error.fieldErrors && Object.entries(error.repopulateFields)) || [])
  //   .map(([field, fieldError]) => {
  //     return `${field}: ${fieldError}`;
  //   })
  //   .join(", ");
  str = str.concat((error.globalErrors || []).join(", "));

  return `Error: ${str}`;
};
